module.exports = __webpack_public_path__ + "img/beer_id-44.1b60ff73.png";